import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderList',
})
export class OrderListPipe implements PipeTransform {
  transform(value: any[], ...args: any[]): any[] {
    const list = [...args[0]];
    list.push(...value);
    const set = new Set();
    return list.filter((el: any) => {
      const duplicate = set.has(el.uuidFirebase);
      set.add(el.uuidFirebase);
      return !duplicate;
    });
  }
}
